/*
* Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
* This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
* The receipt or possession of this program does not convey any rights to use, reproduce or disclose
* its contents in whole or in part, without the specific written consent of Inovalon, Inc.
* Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
* is a violation of the copyright laws and may subject you to criminal prosecution.
*/
import React, { Fragment } from 'react'
import parse from 'html-react-parser'
import { ICLine } from '../../../../services/CoverageDiscoveryResponseStateManager/contracts'

export interface IBenefitDetailsProps {
	data: ICLine[]
}

interface IBenefitDetailsState {
	collapse: number
}

export class BenefitDetailsComponent extends React.Component<IBenefitDetailsProps, IBenefitDetailsState> {
	constructor(props: Readonly<IBenefitDetailsProps>) {
		super(props)
		this.state = { collapse: 0 }
	}

	render(): JSX.Element[] {
		const benefitDetailsModel = this.props.data
		return benefitDetailsModel.map((line, index) => {
			const isFirstLine = index === 0
			return (
				<Fragment key={index}>
					{!isFirstLine && <br />}
					{line.sections.map((section, index1) => {
						const value = parse(section.isBold ? `<strong key=${index1}>${section.value}</strong>` : section.value)
						return <span key={index1}> {value}</span>
					})}
				</Fragment>
			)
		})
	}
}
